import SearchIcon from 'icons/search.svg'
import CreateIcon from 'icons/create.svg'
import DeleteIcon from 'icons/remove.svg'
import HelpIcon from 'icons/help.svg'
import LogoutIcon from 'icons/logout.svg'
import SaveIcon from 'icons/save.svg'
import { type IIconMenuArgs } from './types'
import { Alert } from '@mui/material'
import styles from './styles.module.css'
import { IconButton } from 'entities/IconButton'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'app/store'
import { connect } from 'react-redux'

const mapStateToProps = (state: RootState) => ({
  errorMessage: state.alertSlice.errorMessage,
  infoMessage: state.alertSlice.infoMessage,
})

export const IconMenu = connect(mapStateToProps)(({
  onSearchClick,
  onCreateClick,
  onDeleteClick,
  onSaveClick,
  errorMessage,
  infoMessage,
}: IIconMenuArgs) => {

  const navigate = useNavigate()

  const logout = () => {
    navigate('/')
  }

  return <div className={styles.IconMenu}>
    {onSearchClick && <IconButton icon={SearchIcon} onClick={onSearchClick} />}
    {onCreateClick && <IconButton icon={CreateIcon} onClick={onCreateClick} />}
    {onDeleteClick && <IconButton icon={DeleteIcon} onClick={onDeleteClick} />}
    {onSaveClick && <IconButton icon={SaveIcon} onClick={onSaveClick} />}
    <div className={styles.AlertBar}>
      {errorMessage && <Alert severity={'error'}>{errorMessage}</Alert>}
      {infoMessage  && <Alert severity={'info'}>{infoMessage}</Alert>}
    </div>
    <div className={styles.RightCommonControl}>
      {/* <div className={styles.Help}>
        <IconButton icon={HelpIcon} onClick={() => {}} />
      </div> */}
      <div className={styles.Logout}>
        <IconButton icon={LogoutIcon} onClick={logout} />
      </div>
    </div>
  </div>
})
